
import { Tab } from '@mui/material';
import PageTabLink, { IPageTabLinkProps } from './PageTabLink';

const PageTab = (props: IPageTabLinkProps) => (
    <Tab 
        component={PageTabLink}
        {...props}
    />
);

export default PageTab;